import { Query } from '@apollo/client/react/components';
import React from 'react';
import { VirtualConnectionCustomSqlDocument, VirtualConnectionCustomSqlQuery, VirtualConnectionCustomSqlQueryVariables } from '../../../../../gen-src/queries';
import { RenderQueryResult } from '../renderQueryResult';
import { CustomSQLTable, CustomSqlTextLink } from './CustomSqlDialog';

export type VirtualConnectionCustomSqlQueryWrapperProps = {
  readonly virtualConnectionId: string;
};

export function VirtualConnectionCustomSqlQueryWrapper(props: VirtualConnectionCustomSqlQueryWrapperProps): JSX.Element {

  return (
    <Query<VirtualConnectionCustomSqlQuery, VirtualConnectionCustomSqlQueryVariables>
      query={VirtualConnectionCustomSqlDocument}
      variables={{ vizportalUrlId: props.virtualConnectionId }}
    >
      {result => <RenderQueryResult result={result} renderers={{
        renderData: renderCustomSqlQueries
      }} />}
    </Query>
  )
}

function renderCustomSqlQueries(data: VirtualConnectionCustomSqlQuery): JSX.Element | null {
  const connection = data && data.virtualConnections ? data.virtualConnections[0] : null;
  if (!connection) {
    return null;
  }

  const customSqlMap = new Map();
  connection.tables.forEach((table) => {
    table.columns.forEach((column) => {
      if (column.remoteColumn?.table?.__typename === 'CustomSQLTable') {
        customSqlMap.set(column.remoteColumn.table.id, column.remoteColumn.table);
      }
    });
  });

  if (customSqlMap.size === 0) {
    return null;
  }

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const customSqlTables: Array<CustomSQLTable> = Array.from(customSqlMap.values());
  return (
    <CustomSqlTextLink
      containsUnsupportedCustomSql={customSqlTables.some(table => table.isUnsupportedCustomSql ?? false)}
      customSQLTables={customSqlTables}
      contentType={connection.__typename}
    />
  );
}

